import { useState } from 'react';
import { cn } from '@/utils/styles';

import { AnimationShell } from '@/components';
import { GoUpgradeModal } from '@/features/users';

import { OpportunityCards } from './opportunity-cards';
import { useOpportunityDetails } from '../../../hooks';

export type OpportunityHighlightsProps = {
  readonly id: string;
  readonly tabActive: number;
  readonly onTabChange: (index: number) => void;
};

export function OpportunityTopPanel({ id, tabActive, onTabChange }: OpportunityHighlightsProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { normalizedOpportunity: opportunity } = useOpportunityDetails(id);
  if (!opportunity) return null;

  return (
    <div className="pt-24">
      <AnimationShell type="opacity" className={cn('mx-auto w-full shrink-0')}>
        <div className="space-y-4 px-1 pt-4">
          <OpportunityCards opportunity={opportunity} />
        </div>
        <GoUpgradeModal open={isModalOpen} setOpen={setIsModalOpen}></GoUpgradeModal>
      </AnimationShell>
    </div>
  );
}
